const Start=()=>{

  return(
    <dıv style={{display:'flex',width:'100%',height:`100%`}}>
      <div style={{}}>
        <img
        style={{width:70,background:0}}
        src={require('../../Assets/SnowIcon.png')}/>
        <div style={{fontSize:25,textTransform:'capitalize',background:0}}>
          AeithA
        </div>
        <div style={{fontSize:15,color:'silver',marginTop:window.innerHeight*0.03,background:0}}>
          SADE BİR WEBSİTENİZ OLSUN
        </div>
      </div>
    </dıv>
  );
}
export default Start;
